var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0013 24.0055H8.8773C5.44797 24.0002 2.66797 21.3242 2.66797 18.0228C2.66797 14.7228 5.44797 12.0468 8.8773 12.0468C9.4013 9.6975 11.2693 7.78017 13.7773 7.01617C16.284 6.2535 19.052 6.75884 21.036 8.3495C23.02 9.93617 23.9186 12.3588 23.396 14.7082H24.716C26.556 14.7082 28.1426 15.7895 28.8866 17.3562M25.3346 29.3335V21.3335M25.3346 21.3335L29.3346 25.3335M25.3346 21.3335L21.3346 25.3335",
    stroke: "#C7C7C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.1e51e91128e3eaecb9f3319c9441c850.svg";
export { ForwardRef as ReactComponent };